import React from 'react'
import {ReactComponent as ShoppingIcon} from '../../assets/shoppingBag.svg'
import './cartIcon.styles.css'
import {selectCartItemsCount} from '../../redux/cart/cart.selectors'
import {createStructuredSelector} from 'reselect'
import {connect} from 'react-redux'
import {toggleCartHidden} from '../../redux/cart/cart.actions'
// import CartItem from '../Cart-item/cart-item.component'
const CartIcon =({toggleCartHidden , itemCount}) =>(
    <div className='cart-icon' onClick={toggleCartHidden}>
        <ShoppingIcon className='shopping-icon'/>
        <span className='item-count' style={{color:"white"}}>{itemCount}</span>

    </div>
);
const mapDispatchToProps =dispatch=>({
 toggleCartHidden:()=>dispatch(toggleCartHidden())
});

const mapStateToProps =createStructuredSelector({
    itemCount:selectCartItemsCount
    })
export default connect(mapStateToProps,mapDispatchToProps) (CartIcon); 